import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import Link from 'next/link';
export function AppExperienceContactUs(t0) {
  const $ = _c(8);
  const {
    heading,
    ctaText,
    href
  } = t0;
  let t1;
  if ($[0] !== heading) {
    t1 = <h2 className="font-heading2">{heading}</h2>;
    $[0] = heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ctaText || $[3] !== href) {
    t2 = <Button as={Link} href={href} variant="secondary">{ctaText}</Button>;
    $[2] = ctaText;
    $[3] = href;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="rounded-3xl bg-lightblue px-6 py-8 sm:p-12"><div className="flex flex-col items-center gap-y-6 sm:items-start">{t1}{t2}</div></div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}